/**
 * WAI-ARIA tabs keyboard pattern (horizontal tablist).
 *
 * @param {React.KeyboardEvent} event
 * @param {{ count: number, selectedIndex: number, onSelectIndex: (index: number) => void, orientation?: "horizontal" | "vertical" }} options
 */
export function handleTabListKeyDown(event, {
  count,
  selectedIndex,
  onSelectIndex,
  orientation = "horizontal",
}) {
  if (count <= 0) {
    return;
  }

  const { key } = event;
  const isHorizontal = orientation === "horizontal";
  const nextKey = isHorizontal ? "ArrowRight" : "ArrowDown";
  const previousKey = isHorizontal ? "ArrowLeft" : "ArrowUp";
  let nextIndex = selectedIndex;

  if (key === nextKey) {
    nextIndex = (selectedIndex + 1) % count;
  } else if (key === previousKey) {
    nextIndex = (selectedIndex - 1 + count) % count;
  } else if (key === "Home") {
    nextIndex = 0;
  } else if (key === "End") {
    nextIndex = count - 1;
  } else {
    return;
  }

  event.preventDefault();
  onSelectIndex(nextIndex);
}
